var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headWrapper"},[_c('div',{staticClass:"flexSpaceBetween",staticStyle:{"padding-left":"20px","padding-right":"25px","padding-top":"5px"}},[_c('div',{staticStyle:{"text-align":"center","width":"100%"}},[_c('router-link',{attrs:{"to":'/'}},[_c('img',{attrs:{"src":"https://raizzoncdn.b-cdn.net/home/raizzon-logo-transparent.png","width":"80px","alt":""}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2197c9d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Index.vue
// module id = 69
// module chunks = 0